import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import { useTheme } from '@mui/material/styles';
import UserPaymentTable from './UserPaymentTable';
import { InfoSquareIcon } from '../../../components/icons/InfoSquareIcon';
import SuiteUITabs from '../../../components/SuiteUiTabs';

const PaymentTable = () => {
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();

    const { view: activeView } = useParams();

    return (
        <div className='pt-[16px]'>
            {location.state !== null && location.state?.newTransactionAlert && (
                <div className='mt-[-1rem] mb-8'>
                    <Alert
                        icon={<InfoSquareIcon />}
                        severity='info'
                        sx={{
                            background: 'rgba(0, 136, 178, 0.06)',
                            borderRadius: '3px',
                            border: '1px solid #0088B2',
                            color: theme.palette.primary.main
                        }}
                    >
                        One new payment made.
                    </Alert>
                </div>
            )}

            <div className='mb-2  px-4 lg:px-0'>
                <SuiteUITabs
                    tabs={[
                        { label: 'Transactions', value: 'transactions' },
                        { label: 'Beneficiaries', value: 'beneficiaries' },
                        { label: 'Approvals', value: 'approvals' }
                    ]}
                    activeTab={activeView || 'transactions'}
                    setActiveTab={(val) => navigate(`/payments/${val}`)}
                />
            </div>

            <UserPaymentTable activeView={activeView || ''} />
        </div>
    );
};

export default PaymentTable;
